<script setup lang="ts">
import { storeToRefs } from '#imports';
import { YandexSmartCaptcha } from '@gladesinger/vue3-yandex-smartcaptcha';

import TheHeader from '@/widgets/header/the-header.vue';
import TheFooter from '@/widgets/footer/components/the-footer.vue';
import ThePanelAction from  '@/widgets/panel-action/components/the-panel-action.vue';
import DialogUserWrapper from '@/entities/User/components/dialog-user-wrapper.vue';
import DialogResponse from '@/widgets/dialog-response/components/dialog-response.vue';

import { useCaptchaStore } from '@/features/captcha/store';

const captchaStore = useCaptchaStore();
const { yaCaptcha, captchaProps } = storeToRefs(captchaStore);
const { setCaptchaToken, captchaReset } = captchaStore;
</script>

<template>
	<div class="page">
		<the-header class="page__header" />

		<main class="page__main">
			<slot />
		</main>

		<the-footer class="page__footer" />

		<client-only>
			<the-panel-action />
			<dialog-user-wrapper />
			<dialog-response />
			<yandex-smart-captcha
				ref="yaCaptcha"
				v-bind="captchaProps"
				@on-success="setCaptchaToken"
				@on-token-expired="captchaReset"
			/>
		</client-only>

		<div id="dialog" />
	</div>
</template>
